import React, { Fragment, useState } from "react";
import Header from "./componentes/Header";
import Formulario from "./componentes/Formulario";
import Mensaje from "./componentes/Mensaje";
import Resultado from "./componentes/Resultado";
import Spinner from "./componentes/Spinner";
import Footer from "./componentes/Footer";

function App() {
  //definir state
  //cantidad es el valor del state
  //guardarCantidad es la funcion para modificar o guardar
  const [cantidad, guardarCantidad] = useState(0);
  const [plazo, guardarPlazo] = useState("");
  const [total, guardarTotal] = useState(0);
  const [cargando, guardarCargando] = useState(false);
  const [nota, guardarNota] = useState(0);
  const [ponderacion, guardarPonderacion] = useState(0);

  //carga condicional de un componente
  let componente;

  if (cargando) {
    componente = <Spinner />;
  } else if (total === 0) {
    componente = <Mensaje />;
  } else {
    componente = (
      <Resultado
        nota={nota}
        guardarNota={guardarNota}
        ponderacion={ponderacion}
        guardarPonderacion={guardarPonderacion}
      />
    );
  }

  return (
    <Fragment>
      <Header />
      <div className="container">
        <Formulario
          cantidad={cantidad}
          guardarCantidad={guardarCantidad}
          plazo={plazo}
          guardarPlazo={guardarPlazo}
          guardarTotal={guardarTotal}
          
          guardarCargando={guardarCargando}
          nota={nota}
          guardarNota={guardarNota}
          ponderacion={ponderacion}
          guardarPonderacion={guardarPonderacion}
        />
        <div className="mensajes">{componente}</div>
      </div>
      <Footer />
    </Fragment>
  );
}

export default App;
